import {createAsyncThunk} from '@reduxjs/toolkit';
import {Axios} from '../../../axiosHelper';
import {DeleteMqttMessagesRequest, MqttGrabListResponse, ReadSaveMessageFlagResponse, SetSaveMessageFlagRequest} from '../../data/mqttGrab';
import {ResponseBase} from '../../data';

export const getMqttGrabList = createAsyncThunk(
    'mqttGrab/getList',
    async (systemId: string, {signal}) => {
        const response = await Axios.get<MqttGrabListResponse>('/efe/device/mqtt-grab-list', {
            params: {systemId},
            signal
        });
        if (response.data.responseCode !== 'SUCCESS') {
            throw new Error(response.data.responseCode);
        }
        return response.data.mqttGrabList;
    }
);

export const deleteMqttMessages = createAsyncThunk(
    'mqttGrab/deleteMessages',
    async (request: DeleteMqttMessagesRequest, {signal}) => {
        if (!request.systemId.trim() || (request.scope === 'message' && !Number.isSafeInteger(request.mqttMessageId))) {
            throw new Error('INVALID_PARAMS');
        }
        const params = request.scope === 'message'
            ? {systemId: request.systemId, mqttMessageId: request.mqttMessageId}
            : {systemId: request.systemId};
        const response = await Axios.delete<ResponseBase>('/efe/device/delete-mqtt-message', {params, signal});
        if (response.data.responseCode !== 'SUCCESS') {
            throw new Error(response.data.responseCode);
        }
        return response.data;
    }
);

export const readSaveMessageFlag = createAsyncThunk(
    'mqttGrab/readSaveMessageFlag',
    async (systemId: string, {signal}) => {
        if (!systemId.trim()) throw new Error('INVALID_PARAMS');
        const response = await Axios.get<ReadSaveMessageFlagResponse>('/efe/device/read-save-message-flag', {
            params: {systemId}, signal
        });
        if (response.data.responseCode !== 'SUCCESS' || typeof response.data.saveMessage !== 'boolean') {
            throw new Error(response.data.responseCode === 'SUCCESS' ? 'INVALID_FORMAT' : response.data.responseCode);
        }
        return response.data.saveMessage;
    }
);

export const setSaveMessageFlag = createAsyncThunk(
    'mqttGrab/setSaveMessageFlag',
    async (request: SetSaveMessageFlagRequest, {signal}) => {
        if (!request.systemId.trim() || typeof request.saveMessage !== 'boolean') throw new Error('INVALID_PARAMS');
        const response = await Axios.put<ResponseBase>('/efe/device/set-save-message-flag', null, {
            params: {systemId: request.systemId, saveMessage: request.saveMessage}, signal
        });
        if (response.data.responseCode !== 'SUCCESS') throw new Error(response.data.responseCode);
        return request.saveMessage;
    }
);
